import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

/**
 * 재사용 가능한 사이드바 메뉴 컴포넌트
 *
 * @param {Object} props
 * @param {Array} props.menuItems - 메뉴 항목 배열 [{id, label, path}, ...]
 * @param {string} props.currentNo - 현재 선택된 메뉴 번호
 *
 * @example
 * ```jsx
 * const menuItems = [
 *   { id: '1', label: '인사말', path: '/introduce/1' },
 *   { id: '2', label: '연혁', path: '/introduce/2' },
 * ];
 *
 * <SideBar menuItems={menuItems} currentNo={no} />
 * ```
 */
const SideBar = ({ menuItems, currentNo }) => {
  return (
    <MenuList>
      {menuItems.map((item) => (
        <MenuItem key={item.id}>
          <StyledNavLink to={item.path} $isActive={currentNo === item.id}>
            {item.label}
          </StyledNavLink>
        </MenuItem>
      ))}
    </MenuList>
  );
};

export default SideBar;

/* Styled Components */

const MenuList = styled.ol`
  /* 데스크톱 기본 스타일 */
  margin-top: 31px;
  font-size: 30px;
  width: 230px;
  margin-left: 0;
  box-sizing: border-box;

  /* 모바일 스타일 - 탭 형식 */
  @media (max-width: 767px) {
    display: flex;
    width: 100%;
    max-width: 100%;
    margin-top: 0;
    overflow-x: auto;
    flex-wrap: wrap;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;

    /* 스크롤바 숨기기 */
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

const MenuItem = styled.li`
  /* 데스크톱 기본 스타일 */
  width: 230px;
  margin-left: 0;

  /* 모바일 스타일 - 탭 */
  @media (max-width: 767px) {
    flex: 1;
    width: auto;
  }
`;

const StyledNavLink = styled(NavLink)`
  /* 데스크톱 기본 스타일 */
  font-size: 17px;
  font-family: 'Nanum Square Bold';
  display: block;
  color: ${(props) => (props.$isActive ? '#E5857C' : '#666666')};
  background-color: ${(props) => (props.$isActive ? '#FBF1F0' : '#ffffff')};
  border-bottom: 1px solid #cecece;
  border-top: 1px solid #cecece;
  width: 100%;
  height: 55px;
  line-height: 55px;
  box-sizing: border-box;
  text-decoration: none;
  padding-left: 20px;

  &:hover {
    background-color: ${(props) => (props.$isActive ? '#FBF1F0' : '#f9f9f9')};
  }

  /* 모바일 스타일 - 탭 */
  @media (max-width: 767px) {
    font-size: 14px;
    height: 45px;
    line-height: 45px;
    padding: 0 15px;
    text-align: center;
    border-right: 1px solid #cecece;
    border-bottom: 2px solid
      ${(props) => (props.$isActive ? '#E5857C' : '#cecece')};
    border-top: none;
    white-space: nowrap;

    &:first-child {
      border-left: 1px solid #cecece;
    }
  }

  @media (min-width: 768px) {
    font-size: 16px;
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
  }
`;
